import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import ContributionTimeline from 'tio-employee/components/slr/contribution-timeline';
import type { ContributionHistoryData } from 'tio-employee/services/reimagined-data';

interface SlrPaymentHistorySignature {
  Args: {
    model: ContributionHistoryData | undefined;
  };
}

export default class SlrPaymentHistoryRouteComponent extends Component<SlrPaymentHistorySignature> {
  get payments() {
    return this.args.model?.payments ?? [];
  }

  <template>
    <VStack class="w-full min-w-0 gap-4">
      <PageHeader @title={{t "slr.payment_history"}} @sticky={{false}}>
        <:actions>
          <LinkTo
            @route="authenticated.slr.dashboard"
            class="tio-text-sm-medium tio-fg-info hover:tio-fg-info-body"
          >
            {{t "slr.back_to_dashboard"}}
          </LinkTo>
        </:actions>
      </PageHeader>

      <ContributionTimeline @payments={{this.payments}} />
    </VStack>
  </template>
}
